import { Component, OnInit, ViewEncapsulation, PLATFORM_ID, NgZone, Inject, AfterViewInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BigNumber } from "ethers";
import { Router, ActivatedRoute, Params } from '@angular/router';
import spellsJson from 'assets/json/spell.json'
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { v4 as uuidv4 } from 'uuid';
import { switchMap, take, takeWhile, timer } from 'rxjs';
import { ONRAMPER_QUERY_PARAM, convertJSONToQueryParam } from 'app/common/components/onramper/onramper.config';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { environment } from 'environments/environment';
import { PlaydexService } from 'app/services/contract/contracts-services/playdex.service';
import { NFTService, NFTv2Service } from 'app/services/contract/contracts-services/nft.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { TokenService } from 'app/services/contract/contracts-services/token.service';
import { MarketplaceBidService, MarketplaceService } from 'app/services/contract/contracts-services/marketplace.service';
import { BNBService } from 'app/services/contract/contracts-services/bnb.service';
import { PancakeV2Service } from 'app/services/contract/contracts-services/pancake.service';
//import {SimpleGlobal} from 'ngx-simple-global'
// amCharts imports
/*import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';*/
declare const analytics
declare const Simplex

@Component({
  selector: 'app-kryptomon-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DetailsComponent implements OnInit, AfterViewInit {

  // public account
  public kryptomonsV1
  public kryptomonsV2
  public isV1Kryptomon
  public isV2Kryptomon
  public kryptomon
  public hatchingTime
  public showTextInput
  public kryptomonName
  public oldKryptomonName
  public loadingName
  public hasAllowance
  public loadingAllowance
  public kmonBalance
  public selectedElement
  public selectedFamilyCard = [true, false]
  public spells: any = []
  public spellDescription
  public spellName
  public trainingLevels: any = []
  public caringLevels: any = []
  public skillsArray: any = []
  public chunkedSkills: any = []
  public otherKryptomons: any = [];
  public navigatingIndex
  public kryptomonsV2Navigation: any = []
  public showTransferModal
  public showSaleModal
  public validAddress
  public receiverAddress
  public isLoading
  public isSuccess
  public listingPrice
  public expirationDate
  public kmonValue
  public kmonPrice
  public confirmPrice
  public showConfirmationListing
  public expirationDateUnix
  public showBreedModal
  public breedingPrice
  public filterActivity
  public activityExist: any = [false, false, false, false]
  public isRented
  public isUserOf
  public showBidModal
  public bidAmount
  public showConfirmationBidding
  public showBuyModal
  public bnbBalanceInit
  public showWidget
  public waitingForFunds
  public kmonBNBPrice
  public loadingSwap
  public fundsArrived
  public simulateSuccess
  public isLonger
  amountSelected;
  showOnramper: boolean = false;
  onramperQueryParam: { [key: string]: string } = ONRAMPER_QUERY_PARAM();
  onramperQUeryParamString: string;
  srcOnramper: SafeResourceUrl;
  partnerContext: string;
  bnbAmountToConvert: number;
  wallet: string;
  //public hideRightNavigation
  //private root!: am5.Root;

  @ViewChild('scrollableOthers', { read: ElementRef }) public scrollableOthers: ElementRef<any>;

  public evolutionTimes = [
    259200, //3 days
    2629743, //1 month
    63113852, //24 months
    94670778 //36 months
  ];

  text: any = {
    Year: '',
    Month: '',
    Weeks: "",
    Days: "",
    Hours: "",
    Minutes: "",
    Seconds: "",
    MilliSeconds: ""
  };

  divider = ':'
  //@Inject(PLATFORM_ID) private platformId: Object, private zone: NgZone,
  constructor(
    private zone: NgZone,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private eRef: ElementRef,
    private userService: UserService,
    private web3Service: Web3Service,
    private playdexService: PlaydexService,
    private nftService: NFTService,
    private nftv2Service: NFTv2Service,
    private contractsService: ContractsService,
    private tokenService: TokenService,
    private marketPlaceService: MarketplaceService,
    private marketPlaceBidService: MarketplaceBidService,
    private bnbService: BNBService,
    private pancakeV2Service: PancakeV2Service
  ) {

    this.kryptomonsV1 = [];
    this.kryptomonsV2 = [];
    this.showBidModal = false;
    this.showConfirmationBidding = false;
    this.navigatingIndex = 0;
    this.showTextInput = false;
    this.showTransferModal = false;
    this.loadingName = false;
    this.hasAllowance = false;
    this.loadingAllowance = false;
    this.validAddress = false;
    this.isLoading = false;
    this.isSuccess = false;
    this.showSaleModal = false;
    this.showConfirmationListing = false;
    this.kmonPrice = 0;
    this.expirationDateUnix = 0;
    this.showBreedModal = false
    this.isRented = false;
    this.showBuyModal = false;
    this.showWidget = false;
    this.waitingForFunds = false;
    this.loadingSwap = false;
    this.fundsArrived = false;
    this.simulateSuccess = false;
    this.isLonger = false;

    this.route.params.subscribe(async (params: Params) => {
      var id = params['id']
      if (id != undefined) {
        this.wallet = this.userService._userInfoData.recordedWallet;
        this.getKmonBalance();
        this.getHatchingTime();
        this.setAllowance()
        this.populatePage(id)

        // if (this.appComponent.accounts == undefined) {
        //   this.appComponent.accountsObservable.subscribe(async (item: any) => {
        //     this.wallet = item[0];
        //     if (this.wallet !== undefined && this.wallet !== "") {
        //       this.getKmonBalance();
        //       this.getHatchingTime();
        //       this.setAllowance()
        //       this.populatePage(id)
        //       //this.checkKMONPrice();
        //       //this.setAllowance();

        //       console.log(this.wallet)
        //     }
        //   });
        // } else {
        //   this.wallet = this.appComponent.accounts[0];
        //   this.getKmonBalance();
        //   this.getHatchingTime();
        //   this.setAllowance()
        //   this.populatePage(id)
        //   //this.checkKMONPrice();
        //   //this.setAllowance();

        //   console.log(this.wallet)
        // }
      } else {
        this.router.navigate(['/kryptomons'])
      }
    })

  }


  ngAfterViewInit() {

  }


  ngOnInit(): void {
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  closeSimplex() {
    Simplex.unload();
    this.showWidget = false;
    this.isLoading = false;
  }

  checkKMONPrice() {
    this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
      this.kmonBNBPrice = item.kryptomon.bnb;
    })
  }
  //https://api-staging-n7ni4.ondigitalocean.app
  async populatePage(id) {
    await this.getKryptomons().then(async () => {
      await this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/kryptomons/detail?offset=0&limit=1000").subscribe(async (response: any) => {
        for (let i = 0; i < response.length; i++) {
          if (response[i].isStarter) {
            this.kryptomonsV2.push({ tokenId: response[i].tokenId, isMigrating: false });
            this.kryptomonsV2Navigation.push(response[i].tokenId)
          }
        }
        console.log(this.kryptomonsV2)
        console.log(id)
        const checkOwnership = obj => obj.tokenId == id;
        if (!this.kryptomonsV1.some(checkOwnership)) {
          console.log(this.kryptomonsV2)
          if (!this.kryptomonsV2.some(checkOwnership)) {
            console.log('hered')
            this.isV1Kryptomon = false;
            this.isV2Kryptomon = false;
            const listedBalance = await this.playdexService.contract.methods.getLenderOffersNumber("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.wallet).call();
            console.log(listedBalance)
            const listedPromises = Array.from({ length: parseInt(listedBalance) }, async (_, i) => {
              return this.playdexService.contract.methods.getTokenOfLenderByIndex("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.wallet, i).call();
            });
            const listedTokenIds = Promise.all(listedPromises)
            listedTokenIds.then(async (item) => {
              for (let i = 0; i < item.length; i++) {
                if (item[i] == id) {
                  this.getDetails(id);
                  this.isRented = true;
                  break;
                }
              }
              let userOf = await this.nftv2Service.contract.methods.userOf(id.toString()).call();
              if (userOf !== this.wallet) {
                this.isUserOf = false;
              } else {
                this.isUserOf = true;
              }
              if (!this.isRented && !this.isUserOf) {
                console.log('theres')
                //this.router.navigate(['/hub/kryptomons'])
                this.getDetails(id);
              } else if (this.isUserOf) {
                console.log(this.isUserOf)
                this.getDetails(id);
              }

            })
            //this.router.navigate(['/hub/kryptomons'])
            //this.getDetails(id) 
          } else {
            console.log('here')
            this.isUserOf = true
            this.isV1Kryptomon = false;
            this.isV2Kryptomon = true;
            this.getDetails(id)
          }
        } else {
          console.log('heres')
          this.isV1Kryptomon = true;
          this.isV2Kryptomon = false;
          this.router.navigate(['/hub/kryptomons'])
        }
        console.log(this.isV2Kryptomon)
        console.log(this.isV1Kryptomon)
      })
    });
    await this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
      console.log(item);
      this.kmonValue = item.kryptomon.usd;
      this.kmonBNBPrice = item.kryptomon.bnb;
    })
  }

  async getKryptomons() {
    this.kryptomonsV1 = [];
    this.kryptomonsV2 = [];
    console.log('getKryptomons')
    await this.nftService.contract.methods
      .ownedKryptomons()
      .call({
        from: this.wallet,
      })
      .then(async (receipt) => {
        console.log(receipt);
        if (receipt.length > 0) {
          for (let i = 0; i < receipt.length; i += 1) {
            //this.getKryptomonDetails(receipt[i]);
            this.kryptomonsV1.push({ tokenId: receipt[i], isMigrating: false });

          }
        } else {
          //this.fetchKryptomon1 = true;
        }
        await this.nftv2Service.contract.methods
          .ownedKryptomons()
          .call({
            from: this.wallet,
          })
          .then(async (receipt) => {
            console.log(receipt);
            if (receipt.length > 0) {
              for (let i = 0; i < receipt.length; i += 1) {
                //this.getKryptomonsDetails(receipt[i]);
                this.kryptomonsV2.push({ tokenId: receipt[i], isMigrating: false });
                this.kryptomonsV2Navigation.push(receipt[i])
              }

            } else {
              //this.fetchKryptomon2 = true;
            }



            //this.fetchKryptomon = true;

          }).catch((err) => {
            console.log(err, 'err')
            //this.fetchKryptomon = true;
          });
      })
      .catch((err) => {
        console.log(err, 'err');
        //this.fetchKryptomon = true;
      });

  }

  async getDetails(id) {
    this.navigatingIndex = this.kryptomonsV2Navigation.indexOf(id);
    this.spells = []
    this.trainingLevels = []
    this.caringLevels = []
    this.skillsArray = []
    this.chunkedSkills = []
    this.otherKryptomons = [];
    this.http.get("https://nft-server-h9u8n.ondigitalocean.app/v1/nfts?contractAddress=0x04b0f7d5cb2ce4688497f2525748fb7a9affa394&tokenId=" + id).subscribe(async (extraMarketData: any) => {
      console.log(extraMarketData)
      await this.http.get("https://api-v22.kryptomon.co/kryptomon/" + id).subscribe(async (item: any) => {
        console.log(item)
        //item.rental = false;
        if (item.rental) {
          let rentingStart = new Date(item.startingDate)
          let ry = rentingStart.getFullYear();
          let rm: any = rentingStart.getMonth() + 1; // Months start at 0!
          let rd: any = rentingStart.getDate();

          if (rd < 10) rd = '0' + rd;
          if (rm < 10) rm = '0' + rm;

          let rentingStartFormatted = rd + '/' + rm + '/' + ry;
          item.startingDate = rentingStartFormatted;
        }
        if (this.isRented) {
          item.isRentedOut = true;
        }



        if (item.ranking < 650) {
          item.tierName = "Rookie"
          item.tierNumber = 1
        } else if (item.ranking >= 650 && item.ranking < 700) {
          item.tierName = "Veteran"
          item.tierNumber = 2
        } else {
          item.tierName = "Elite"
          item.tierNumber = 3
        }

        if (item.timeHatched !== null) {
          if (item.isStarter) {
            var date = new Date(item.timeHatched);
          } else {
            var date = new Date(item.timeHatched * 1000);
          }

          const yyyy = date.getFullYear();
          let mm: any = date.getMonth() + 1; // Months start at 0!
          let dd: any = date.getDate();

          if (dd < 10) dd = '0' + dd;
          if (mm < 10) mm = '0' + mm;

          const timeHatchedFormatted = dd + '/' + mm + '/' + yyyy;

          item.timeHatchedFormatted = timeHatchedFormatted;
        }

        if (!item.isStarter) {
          item.order = extraMarketData.data[0].order
          item.nft = {}
          item.nft.contractAddress = extraMarketData.data[0].nft.contractAddress
          item.nft.tokenId = extraMarketData.data[0].nft.tokenId

          if (!extraMarketData.data[0].nft.data.kryptomon.breedingCount) {
            item.breedingDone = 0;
          } else {
            item.breedingDone = extraMarketData.data[0].nft.data.kryptomon.breedingCount;
          }

          //BNB 0x0000000000000000000000000000000000000000
          //USD KMON PEGGED 0xffffffffffffffffffffffffffffffffffffffff
          //KMON legacy 0xc732B6586A93b6B7CF5FeD3470808Bc74998224D

          if (item.order) {
            if (item.order.paymentToken == "0xffffffffffffffffffffffffffffffffffffffff") {
              item.order.tokenPaymentAmount = parseFloat(item.order.priceKMON)
            } else {
              item.order.tokenPaymentAmount = this.web3Service.fromWeiFloat(item.order.price)
            }
          }

          if (!extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) {
            extraMarketData.data[0].nft.data.kryptomon.breedingsLeft = 0;
          }
          console.log(extraMarketData.data[0].nft.data.kryptomon.breedingsLeft)
          item.breedingTotal = parseInt(extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) + parseInt(item.breedingDone)
        }

        if (item.isStarter) {
          var date = new Date(item.timeBorn);
          item.isDestroying = false;
        } else {
          var date = new Date(item.timeBorn * 1000);
        }

        const yyyy = date.getFullYear();
        let mm: any = date.getMonth() + 1; // Months start at 0!
        let dd: any = date.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const timeBornFormatted = dd + '/' + mm + '/' + yyyy;

        item.timeBornFormatted = timeBornFormatted;

        const evolutionTime = this.evolutionTimes[item.status];
        if (item.isStarter) {
          var nextEvolution = (parseInt(item.timeHatched) + (evolutionTime * 1000));
        } else {
          var nextEvolution = (parseInt(item.timeHatched) + evolutionTime) * 1000;
        }



        item.hatchingDate = this.getHatchingDate(item.timeBorn, item.isStarter);
        item.hatchingDateFormatted = new Date(item.hatchingDate * 1000)
        item.isReadyToHatch = item.hatchingDate * 1000 < Date.now() && item.status == 0;
        console.log(nextEvolution)
        item.isReadyToEvolve = nextEvolution < Date.now() && item.status > 0;

        if (!item.isReadyToHatch && item.status == 0) {
          var hatchInterval = setInterval(() => {
            item.hatchingDate = this.getHatchingDate(item.timeBorn, item.isStarter);
            console.log(item.hatchingDate)
            //this.kryptomon.hatchingDateFormatted = new Date(item.hatchingDate*1000)
            this.kryptomon.isReadyToHatch = item.hatchingDate * 1000 < Date.now() && item.status == 0;
            console.log(this.kryptomon)
            //this.kryptomon.isReadyToEvolve = nextEvolution < Date.now() && item.status>0;
            if (this.kryptomon.isReadyToHatch) {
              clearInterval(hatchInterval)
            }
          }, 1000)
        }
        console.log(item.hatchingDate)

        var eggImage
        var babyImage
        var juniorImage

        var imageSelected


        if (item.genes.xFactor == 1) {
          imageSelected = "super"
        } else {
          imageSelected = item.speciality.toLowerCase()
        }

        if (item.extraData.unfreezable == 1) {
          eggImage = "./assets/img/top_special/" + item.elementType + "/" + imageSelected + ".png";
        } else {
          if (item.tokenId == 6188) {
            eggImage = "./assets/img/top_special/custom/6188.png";
          } else {
            eggImage = "./assets/img/" + item.elementType + "/" + imageSelected + ".png";
          }
        }

        babyImage = environment.apiImages + "images/kryptomons/png/kmon_" + item.tokenId + "_png.png"
        juniorImage = environment.apiImages + "images/kryptomons-junior/png/kmon_" + item.tokenId + "_png.png"
        if (item.status == 0) {
          item.image = eggImage;
        } else if (item.status == 1) {
          item.image = babyImage;
        } else if (item.status == 2) {
          item.image = juniorImage;
        }

        if (item.name) {
          this.kryptomonName = item.name
        } else {
          if (item.isStarter) {
            item.name = "S-" + (item.tokenId - 1000000000)
          } else {
            item.name = "#" + item.tokenId
          }
        }
        if (item.isStarter) {
          item.tokenIdFormatted = "S-" + (item.tokenId - 1000000000)
        } else {
          item.tokenIdFormatted = item.tokenId
        }


        if (item.gameMetadata.isFreezed == 1) {
          item.gameStatusImage = "./assets/img/Icon/frozen-icon.svg"
          item.gameStatus = "FROZEN"
        } else {
          item.gameStatusImage = "./assets/img/Icon/alive-icon.svg"
          item.gameStatus = "ALIVE"
        }

        if (item.genes.sex < 5) {
          item.genderIcon = "./assets/img/Icon/female-icon.svg"
        } else {
          item.genderIcon = "./assets/img/Icon/male-icon.svg"
        }

        item.mainFamilyImage = "./assets/img/icons/" + item.elementType.toLowerCase() + ".svg";
        item.secondaryFamilyImage = "./assets/img/icons/" + item.elementTypeSecond.toLowerCase() + ".svg";

        item.trainedLevel = Math.round((item.gameMetadata.attackLevel + item.gameMetadata.defenseLevel + item.gameMetadata.hpLevel + item.gameMetadata.mainFamilyTalentLevel + item.gameMetadata.secondaryFamilyTalentLevel) / 5)
        if (isNaN(item.trainedLevel)) {
          item.trainedLevel = 0;
        }
        item.mainGenes = item.genes[item.elementType.toLowerCase()]
        item.mainTalent = item.genes[item.elementType.toLowerCase() + "Talent"]

        item.secondGenes = item.genes[item.elementTypeSecond.toLowerCase()]
        item.secondTalent = item.genes[item.elementTypeSecond.toLowerCase() + "Talent"]




        let stats: any = []
        stats["physicalAttack"] = { name: 'Physical Attack' };
        stats["physicalDefense"] = { name: 'Physical Defense' };
        stats["mainElementalAttack"] = { name: item.elementType + " Attack" };
        stats["secondaryElementalAttack"] = { name: item.elementTypeSecond + " Attack" };
        stats["elementalDefense"] = { name: 'Elemental Defense' };
        stats["healthPoints"] = { name: 'Health Points' };
        stats["critical"] = { name: 'Critical Hits' };
        stats["evasion"] = { name: 'Evades' };

        console.log(stats.physicalAttack)
        stats["physicalAttack"].value = parseInt(item.genes.attack)
        stats["physicalDefense"].value = (parseInt(item.genes.defense) + parseInt(item.genes.instinct)) / 2
        stats["mainElementalAttack"].value = parseInt(item.elementTalent)
        stats["secondaryElementalAttack"].value = parseInt(item.elementTalentSecond)
        stats["elementalDefense"].value = (parseInt(item.genes.defense) + parseInt(item.genes.crazyness)) / 2
        stats["healthPoints"].value = (parseInt(item.genes.healthPoints) + parseInt(item.genes.constitution)) / 2
        stats["critical"].value = parseInt(item.genes.crazyness)
        stats["evasion"].value = parseInt(item.genes.instinct)

        stats["physicalAttack"].valueScaled = Math.round(stats["physicalAttack"].value)
        stats["physicalDefense"].valueScaled = Math.round(stats["physicalDefense"].value)
        stats["mainElementalAttack"].valueScaled = Math.round(stats["mainElementalAttack"].value / 10000 * 100)
        stats["secondaryElementalAttack"].valueScaled = Math.round(stats["secondaryElementalAttack"].value / 10000 * 100)
        stats["elementalDefense"].valueScaled = Math.round(stats["elementalDefense"].value)
        stats["healthPoints"].valueScaled = Math.round(stats["healthPoints"].value)
        stats["critical"].valueScaled = Math.round(stats["critical"].value)
        stats["evasion"].valueScaled = Math.round(stats["evasion"].value)



        for (let key in stats) {
          if (key == "mainElementalAttack" || key == "secondaryElementalAttack") {
            if (stats[key].value < 3599) {
              stats[key].stars = 1;
            } else if (stats[key].value > 3600 && stats[key].value <= 4224) {
              stats[key].stars = 1.5;
            } else if (stats[key].value > 4224 && stats[key].value <= 4899) {
              stats[key].stars = 2;
            } else if (stats[key].value > 4899 && stats[key].value <= 5264) {
              stats[key].stars = 2.5;
            } else if (stats[key].value > 5264 && stats[key].value <= 6399) {
              stats[key].stars = 3;
            } else if (stats[key].value > 6399 && stats[key].value <= 7224) {
              stats[key].stars = 3.5;
            } else if (stats[key].value > 7224 && stats[key].value <= 8099) {
              stats[key].stars = 4;
            } else if (stats[key].value > 8099 && stats[key].value <= 9024) {
              stats[key].stars = 4.5;
            } else {
              stats[key].stars = 5;
            }
          } else {
            if (stats[key].value <= 59) {
              stats[key].stars = 1;
            } else if (stats[key].value > 59 && stats[key].value <= 64) {
              stats[key].stars = 1.5;
            } else if (stats[key].value > 64 && stats[key].value <= 69) {
              stats[key].stars = 2;
            } else if (stats[key].value > 69 && stats[key].value <= 74) {
              stats[key].stars = 2.5;
            } else if (stats[key].value > 74 && stats[key].value <= 79) {
              stats[key].stars = 3;
            } else if (stats[key].value > 79 && stats[key].value <= 84) {
              stats[key].stars = 3.5;
            } else if (stats[key].value > 84 && stats[key].value <= 89) {
              stats[key].stars = 4;
            } else if (stats[key].value > 89 && stats[key].value <= 94) {
              stats[key].stars = 4.5;
            } else {
              stats[key].stars = 5;
            }
          }
          //sumup = sumup + stats[key].stars;
        }
        item.stats = Object.entries(stats);

        this.selectedElement = item.elementType.toLowerCase();
        this.oldKryptomonName = this.kryptomonName

        for (let i = 0; i < spellsJson.Spells.length; i++) {
          if (this.selectedElement == spellsJson.Spells[i].element) {
            this.spells.push(spellsJson.Spells[i]);
          }
        }

        this.selectFamily(item.elementType, 0)

        for (let key in item.gameMetadata) {
          let trainingObj: any = {}
          if (key == "mainFamilyTalentLevel") {
            trainingObj.name = "Main Element Talent"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.percentage = Math.round((item.gameMetadata[key] / 50) * 100)
            this.trainingLevels.push(trainingObj);
          } else if (key == "secondaryFamilyTalentLevel") {
            trainingObj.name = "Secondary Element Talent"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.percentage = Math.round((item.gameMetadata[key] / 50) * 100)
            this.trainingLevels.push(trainingObj);
          } else if (key == "attackLevel") {
            trainingObj.name = "Attack"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.percentage = Math.round((item.gameMetadata[key] / 50) * 100)
            this.trainingLevels.push(trainingObj);
          } else if (key == "defenseLevel") {
            trainingObj.name = "Resistance"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.percentage = Math.round((item.gameMetadata[key] / 50) * 100)
            this.trainingLevels.push(trainingObj);
          } else if (key == "hpLevel") {
            trainingObj.name = "Stamina"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.percentage = Math.round((item.gameMetadata[key] / 50) * 100)
            this.trainingLevels.push(trainingObj);
          } else if (key == "loveGaugeAmount") {
            trainingObj.name = "Love"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.maxValue = 300
            trainingObj.percentage = Math.round((item.gameMetadata[key] / trainingObj.maxValue) * 100)
            this.caringLevels.push(trainingObj);
          } else if (key == "healingGaugeAmount") {
            trainingObj.name = "Health"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.maxValue = 100
            trainingObj.percentage = Math.round((item.gameMetadata[key] / trainingObj.maxValue) * 100)
            this.caringLevels.push(trainingObj);
          } else if (key == "hapinessGaugeAmount") {
            trainingObj.name = "Happiness"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.maxValue = 100
            trainingObj.percentage = Math.round((item.gameMetadata[key] / trainingObj.maxValue) * 100)
            this.caringLevels.push(trainingObj);
          } else if (key == "feedingGaugeAmount") {
            trainingObj.name = "Fullness"
            trainingObj.value = Math.round(item.gameMetadata[key])
            trainingObj.maxValue = 100
            trainingObj.percentage = Math.round((item.gameMetadata[key] / trainingObj.maxValue) * 100)
            this.caringLevels.push(trainingObj);
          }
        }

        var skillObject: any = {}
        skillObject.name = "Attacking"
        skillObject.skills = [
          { img: "./assets/img/Icon/attack.svg", name: "attack", value: item.genes.attack },
          { img: "./assets/img/Icon/element-talent.svg", name: "main elemental power", value: item.elementTalent },
          { img: "./assets/img/Icon/element-talent.svg", name: "secondary elemental power", value: item.elementTalentSecond },
          { img: "./assets/img/Icon/crazyness.svg", name: "crazyness", value: item.genes.crazyness },
          { img: "./assets/img/Icon/speed.svg", name: "speed", value: item.genes.speed },
        ]

        this.skillsArray.push(skillObject);

        var skillObject: any = {}
        skillObject.name = "Defending"
        skillObject.skills = [
          { img: "./assets/img/Icon/resistance.svg", name: "resistance", value: item.genes.defense },
          { img: "./assets/img/Icon/constitution.svg", name: "constitution", value: item.genes.constitution },
          { img: "./assets/img/Icon/crazyness.svg", name: "crazyness", value: item.genes.crazyness },
          { img: "./assets/img/Icon/training-time.svg", name: "stamina", value: item.genes.healthPoints },
          { img: "./assets/img/Icon/instinct.svg", name: "instinct", value: item.genes.instinct },
        ]

        this.skillsArray.push(skillObject);

        var skillObject: any = {}
        skillObject.name = "Special traits"
        if (item.genes.xFactor == 0) {
          var isSuper = "NO"
        } else {
          var isSuper = "YES"
        }
        if (item.extraData.unfreezable == 0) {
          var isAura = "NO"
        } else {
          var isAura = "YES"
        }
        skillObject.skills = [
          { img: "./assets/img/Icon/super-noborder.svg", name: "super", value: isSuper },
          { img: "./assets/img/Icon/speciality.svg", name: "speciality", value: item.speciality },
          { img: "./assets/img/Icon/aura.svg", name: "aura", value: isAura },
        ]

        this.skillsArray.push(skillObject);

        var skillObject: any = {}
        skillObject.name = "Breeding Info"
        if (item.status > 1 && !item.isStarter) {
          var breedLabel = "breeding price"
          item.breedingOrder = extraMarketData.data[0].breedingOrder
          if (extraMarketData.data[0].breedingOrder) {
            var breedingPrice: any = this.web3Service.fromWeiFloat(extraMarketData.data[0].breedingOrder.price)
          } else {
            var breedingPrice: any = 0;
          }
          if (item.status == 2) {
            var amount_per_year = Math.round(0.075 * item.genes.healthPoints + 1.5)
          } else if (item.status == 3) {
            var amount_per_year = Math.round(0.075 * item.genes.healthPoints - 0.5)
          }
          var cooldownBreed: any = Math.round(300 * (1 - 0.005 * item.genes.speed) / amount_per_year) + " days"
        } else {
          var breedingPrice: any = ""
          var breedLabel = "can't breed yet"
          var cooldownBreed: any = "not available"
        }
        //var breedMutation = Math.round((2/(1+2.78**(-0.033*item.genes.generation))-1)*10000)/100+"%"

        if (item.genes.generation == 0) {
          var breedMutation = "0%"
        } else if (item.genes.generation == 1) {
          var breedMutation = "2.26%"
        } else if (item.genes.generation == 2) {
          var breedMutation = "3.52%"
        } else if (item.genes.generation == 3) {
          var breedMutation = "5.48%"
        } else if (item.genes.generation == 4) {
          var breedMutation = "8.50%"
        } else if (item.genes.generation == 5) {
          var breedMutation = "11.41%"
        } else if (item.genes.generation == 6) {
          var breedMutation = "14.60%"
        } else if (item.genes.generation == 7) {
          var breedMutation = "17.54%"
        } else if (item.genes.generation == 8) {
          var breedMutation = "19.62%"
        } else if (item.genes.generation == 9) {
          var breedMutation = "21.05%"
        } else if (item.genes.generation == 10) {
          var breedMutation = "23.15%"
        } else if (item.genes.generation == 11) {
          var breedMutation = "25.47%"
        } else if (item.genes.generation == 12) {
          var breedMutation = "28.01%"
        } else if (item.genes.generation == 13) {
          var breedMutation = "30.82%"
        } else if (item.genes.generation == 14) {
          var breedMutation = "33.90%"
        } else {
          var breedMutation = "35.00%"
        }

        if (item.matronId == 0) {
          var motherId: any = "minted"
        } else {
          var motherId: any = item.matronId
        }
        if (item.sireId == 0) {
          var fatherId: any = "minted"
        } else {
          var fatherId: any = item.sireId
        }


        this.skillsArray.push(skillObject);

        var skillObject: any = {}
        skillObject.name = "Care & Training"
        skillObject.description = "Attributes that will affect how you should care for your Kryptomon, and how fast it can be trained."
        var trainingTime = Math.round(60.5 - 0.505 * item.genes.smart) + " mins";
        skillObject.skills = [
          { img: "./assets/img/Icon/Caring.svg", name: "affection", value: item.genes.affections },
          { img: "./assets/img/Icon/hunger.svg", name: "hunger", value: item.genes.hunger },
          { img: "./assets/img/Icon/training-time.svg", name: "training time", value: trainingTime },
          { img: "./assets/img/Icon/ego.svg", name: "ego", value: item.genes.ego }
        ]

        this.skillsArray.push(skillObject);

        var skillObject: any = {}
        skillObject.name = "Appearance"
        skillObject.description = "Attributes that will affect the appearance of your Kryptomon."
        if (item.genes.skinType == 0) {
          var skin = "feather"
        } else if (item.genes.skinType == 1) {
          var skin = "skin"
        } else if (item.genes.skinType == 2) {
          var skin = "scale"
        } else if (item.genes.skinType == 3) {
          var skin = "plated"
        } else if (item.genes.skinType == 4) {
          var skin = "fur"
        }
        skillObject.skills = [
          { img: "./assets/img/Icon/skin.svg", name: "skin type", value: skin },
          { img: "./assets/img/Icon/body-size.svg", name: "body size", value: item.genes.bodySize }
        ]

        this.skillsArray.push(skillObject);

        while (this.skillsArray.length > 0) {
          this.chunkedSkills.push(this.skillsArray.splice(0, 2))
        }

        console.log(this.chunkedSkills)
        //extraMarketData
        console.log(this.spells)

        this.kryptomon = item;
        /*setTimeout(()=>{
          this.renderChart(item)
        },100)*/
        item.age = this.getAge(item.timeBorn, item.isStarter)


        item.activities = []

        if (!item.isStarter) {


          const checkhatch = obj => obj.eventName === 'hatching';
          if (!extraMarketData.data[0].activities.some(checkhatch) && item.status > 0) {
            let activity: any = {}
            activity.title = "born";
            activity.img = babyImage;
            activity.timeFormatted = item.timeHatchedFormatted
            item.activities.push(activity)
          }

          extraMarketData.data[0].activities.sort((a, b) => {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return a.date - b.date;
          });
          for (let i = 0; i < extraMarketData.data[0].activities.length; i++) {
            let chainActivity = extraMarketData.data[0].activities[i]
            let activity: any = {};
            if (chainActivity.eventName == "hatching") {
              activity.title = "born";
              activity.img = babyImage;
              activity.timeFormatted = this.formatDate(chainActivity.date)
              item.activities.push(activity)
            } else if (chainActivity.eventName == "evolution") {
              activity.title = "evolved";
              activity.img = juniorImage;
              activity.timeFormatted = this.formatDate(chainActivity.date)
              item.activities.push(activity)
            } else if (chainActivity.eventName == "breed") {
              activity.title = "breed";
              activity.img = "./assets/img/Icon/Breeding.svg";
              activity.timeFormatted = this.formatDate(chainActivity.date)
              activity.partner = chainActivity.extraData[0].value.split("-")[2]
              item.activities.push(activity)
            } else if (chainActivity.eventName == "sold") {
              activity.title = "sold";
              activity.img = "./assets/img/Icon/Sold.svg";
              activity.timeFormatted = this.formatDate(chainActivity.date)
              activity.buyer = chainActivity.extraData[0].value.substr(-6)
              activity.seller = chainActivity.extraData[1].value.substr(-6)
              // activity.amount = Math.round(parseFloat(await this.appComponent.contractService.web3.utils.fromWei(chainActivity.extraData[2].value)) * 100) / 100
              activity.amount = Math.round(this.web3Service.fromWeiFloat(chainActivity.extraData[2].value) * 100) / 100
              if (chainActivity.extraData[3].value == "0x0000000000000000000000000000000000000000") {
                activity.currency = "BNB"
              } else {
                activity.currency = "KMON"
              }
              item.activities.push(activity)
            } else if (chainActivity.eventName == "transfer") {
              console.log(chainActivity.extraData[0].value)
              if (chainActivity.extraData[0].value.toLowerCase() == "0x959d8d3add23ff8D1F5B37D8db09a95F42f8d904".toLowerCase()) {
                activity.title = "renting";
                activity.img = "./assets/img/Icon/playdex.png";
                activity.timeFormatted = this.formatDate(chainActivity.date)
              } else {
                activity.title = "transfer";
                activity.img = "./assets/img/Icon/Transfer.svg";
                activity.timeFormatted = this.formatDate(chainActivity.date)
                activity.buyer = chainActivity.extraData[0].value.substr(-6)
                activity.seller = chainActivity.extraData[1].value.substr(-6)
              }
              item.activities.push(activity)
            }
            //console.log(activity)

          }

          const checkevolved = obj => obj.title === 'evolved';
          const checkbreed = obj => obj.title === 'breed';
          const checktransfer = obj => obj.title === 'transfer';
          const checksold = obj => obj.title === 'sold';


          this.activityExist[0] = item.activities.some(checkevolved)
          this.activityExist[1] = item.activities.some(checkbreed)
          this.activityExist[2] = item.activities.some(checktransfer)
          this.activityExist[3] = item.activities.some(checksold)

        } else {
          item.activities = []
          var activity: any = {}
          activity.title = "laid";
          activity.img = eggImage;
          activity.motherId = motherId
          activity.fatherId = fatherId
          activity.timeFormatted = item.timeBornFormatted;
          item.activities.push(activity)

          if (item.status > 0) {
            var activity: any = {}
            activity.title = "born";
            activity.img = babyImage;
            activity.timeFormatted = item.timeHatchedFormatted
            item.activities.push(activity)
          }
          if (item.status > 1) {
            var activity: any = {}
            activity.title = "evolved";
            activity.img = juniorImage;
            //activity.timeFormatted = this.formatDate(chainActivity.date)
            item.activities.push(activity)
          }
        }


        if (!this.isUserOf) {
          if (this.kryptomon.order) {
            var onSale: any = this.kryptomon.order.priceUSD;
          } else {
            var onSale: any = false
          }
          if (this.kryptomon.breedingOrder) {
            // var onBreed: any = Math.round((parseFloat(this.appComponent.contractService.web3.utils.fromWei(this.kryptomon.breedingOrder.price))) * this.kmonValue * 100) / 100
            var onBreed: any = Math.round(this.web3Service.fromWeiFloat(this.kryptomon.breedingOrder.price) * this.kmonValue * 100) / 100
          } else {
            var onBreed: any = false
          }
          analytics.track('Kryptomon viewed', {
            onSale: onSale, // price in dollar or false 
            breedOrder: onBreed, // price in dollar or false       
            rank: this.kryptomon.tierName, // veteran/elite/rookie
            mainElement: this.kryptomon.elementType, // main element
            secondaryElement: this.kryptomon.elementTypeSecond, // secondaryElement
            rankRaw: this.kryptomon.ranking// number
          });
        }


        this.kryptomonsV2 = this.kryptomonsV2.filter((item) => {
          return item.tokenId !== id
        })
        console.log(this.kryptomonsV2)
        console.log(this.kryptomonsV2.length)
        if (this.kryptomonsV2.length < 6) {
          var lengthFor: any = this.kryptomonsV2.length
          console.log(lengthFor)
        } else {
          var lengthFor: any = 6;
        }
        console.log(lengthFor)
        let kryptomonsV2 = this.kryptomonsV2
        for (let i = 0; i < lengthFor; i++) {
          let id = kryptomonsV2[i].tokenId;
          console.log(id)
          await this.otherKryptomonsDetails(id);
          this.kryptomonsV2 = this.kryptomonsV2.filter((item) => {
            return item.tokenId !== id
          })
        }
        console.log(this.otherKryptomons)
      })
    })
  }

  async otherKryptomonsDetails(id) {
    await this.http.get("https://api-v22.kryptomon.co/kryptomon/" + id).subscribe(async (item: any) => {
      await this.http.get("https://nft-server-h9u8n.ondigitalocean.app/v1/nfts?contractAddress=0x04b0f7d5cb2ce4688497f2525748fb7a9affa394&tokenId=" + id).subscribe((extraMarketData: any) => {

        if (item.ranking < 650) {
          item.tierName = "Rookie"
          item.tierNumber = 1
        } else if (item.ranking >= 650 && item.ranking < 700) {
          item.tierName = "Veteran"
          item.tierNumber = 2
        } else {
          item.tierName = "Elite"
          item.tierNumber = 3
        }
        if (!item.isStarter) {
          item.order = extraMarketData.data[0].order;

          if (item.status > 1) {
            if (!extraMarketData.data[0].nft.data.kryptomon.breedingCount) {
              item.breedingDone = 0;
            } else {
              item.breedingDone = extraMarketData.data[0].nft.data.kryptomon.breedingCount;
            }

            if (item.extraData.unfreezable == 1) {
              item.image = "./assets/img/top_special/" + item.elementType + "/" + imageSelected + ".png";
            } else {
              if (item.tokenId == 6188) {
                item.image = "./assets/img/top_special/custom/6188.png";
              } else {
                item.image = "./assets/img/" + item.elementType + "/" + imageSelected + ".png";
              }
            }

            item.breedingTotal = parseInt(extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) + parseInt(item.breedingDone)
          }
        }
        if (item.status == 0) {

          var imageSelected

          if (item.genes.xFactor == 1) {
            imageSelected = "super"
          } else {
            imageSelected = item.speciality.toLowerCase()
          }

          if (item.extraData.unfreezable == 1) {
            item.image = "./assets/img/top_special/" + item.elementType + "/" + imageSelected + ".png";
          } else {
            item.image = "./assets/img/" + item.elementType + "/" + imageSelected + ".png";
          }
        } else if (item.status == 1) {
          item.image = environment.apiImages + "images/kryptomons/png/kmon_" + item.tokenId + "_png.png"
        } else if (item.status == 2) {
          item.image = environment.apiImages + "images/kryptomons-junior/png/kmon_" + item.tokenId + "_png.png"
        }

        if (!item.name) {
          if (item.isStarter) {
            item.name = "S-" + (item.tokenId - 1000000000)
          } else {
            item.name = "#" + item.tokenId
          }
        }
        if (item.genes.sex < 5) {
          item.genderIcon = "./assets/img/Icon/female-icon.svg"
        } else {
          item.genderIcon = "./assets/img/Icon/male-icon.svg"
        }

        item.mainFamilyImage = "./assets/img/icons/" + item.elementType.toLowerCase() + ".svg";
        item.secondaryFamilyImage = "./assets/img/icons/" + item.elementTypeSecond.toLowerCase() + ".svg";

        this.otherKryptomons.push(item);
      })
    })
  }

  async loadNewOther() {
    if (this.kryptomonsV2.length > 0) {
      let id = this.kryptomonsV2[0].tokenId;
      await this.otherKryptomonsDetails(id);
      this.kryptomonsV2 = this.kryptomonsV2.filter((item) => {
        return item.tokenId !== id
      })
    }
    let width = document.getElementById('otherKryptomon').offsetWidth + 15;
    this.scrollableOthers.nativeElement.scrollTo({ left: (this.scrollableOthers.nativeElement.scrollLeft + width), behavior: 'smooth' });
    console.log(this.otherKryptomons)

    /*if(this.kryptomonsV2.length==0){
      this.hideRightNavigation = true
    }*/
  }

  navigateToLeftOther() {
    let width = document.getElementById('otherKryptomon').offsetWidth + 15;
    this.scrollableOthers.nativeElement.scrollTo({ left: (this.scrollableOthers.nativeElement.scrollLeft - width), behavior: 'smooth' });
  }

  loadPreviousTop() {
    this.navigatingIndex--
    let id = this.kryptomonsV2Navigation[this.navigatingIndex];
    console.log(this.navigatingIndex)
    this.router.navigate(['/kryptomons/details', id])
  }
  loadNextTop() {
    console.log(this.navigatingIndex)
    console.log('----trovami-qui----')
    this.navigatingIndex++
    let id = this.kryptomonsV2Navigation[this.navigatingIndex];
    console.log(this.kryptomonsV2Navigation)
    this.router.navigate(['/kryptomons/details', id])
  }

  selectFamily(family, index) {
    this.selectedElement = family.toLowerCase();
    console.log(this.selectedElement)
    for (let i = 0; i < this.selectedFamilyCard.length; i++) {
      if (i == index) {
        this.selectedFamilyCard[i] = true
      } else {
        this.selectedFamilyCard[i] = false
      }
    }
    this.spells = [];
    for (let i = 0; i < spellsJson.Spells.length; i++) {
      if (this.selectedElement == spellsJson.Spells[i].element) {
        this.spells.push(spellsJson.Spells[i]);
      }
    }
    this.selectSpell(0)
  }

  showNameField() {
    this.showTextInput = !this.showTextInput
    setTimeout(() => {
      document.getElementById("kryptomonName").focus();
    }, 10)
    console.log('focus')
  }

  getHatchingDate(timeBorn, isFreeToPlay) {
    if (isFreeToPlay) {
      var hatchingDateInUnix: any = (parseInt(timeBorn) / 1000) + 180
    } else {
      var hatchingDateInUnix: any = parseInt(timeBorn) + this.hatchingTime;
    }
    return (hatchingDateInUnix + 20);
  }

  async getHatchingTime() {
    this.hatchingTime = parseInt(await this.nftService.contract.methods.timeToHatch().call());
  }

  async saveName() {
    console.log('saveName')
    if (this.kryptomonName !== "" && this.kryptomonName !== undefined && this.kryptomonName != this.oldKryptomonName) {
      //this.loadingName = true;
      var text = "Name my Kryptomon(" + this.kryptomon.tokenId + ") " + this.kryptomonName;

      // var msg = await this.appComponent.contractService.web3.utils.utf8ToHex(text)
      var msg = this.web3Service.utf8ToHex(text);
      var from = this.wallet;
      var params = [msg, from]
      var method = 'personal_sign'

      var name = this.kryptomonName;
      var network = this.web3Service.getNetworkName();
      // var endpoint = this.appComponent.contractService.apiEndPoint;
      var kryptomon = this.kryptomon;

      kryptomon.name = name;

      this.web3Service.getWeb3().currentProvider.sendAsync({
        method,
        params,
        from,
      }, (err, result) => {
        if (err) { //this.loadingName = false; 
          kryptomon.name = this.oldKryptomonName; this.kryptomonName = this.oldKryptomonName;
          this.toastService.genericError();
          return console.error(err);
        }
        if (result.error) { //this.loadingName = false; 
          kryptomon.name = this.oldKryptomonName; this.kryptomonName = this.oldKryptomonName; return console.error(result.error)
        }
        console.log('PERSONAL SIGNED:' + JSON.stringify(result.result))

        let post = {
          id: kryptomon.tokenId,
          name: name,
          network: network,
          signature: result.result,
          enable: true
        }
        analytics.track("renamed kryptomon", { name: name })
        this.http.post(environment.apiBaseUrlV22 + "/kryptomons-meta/" + post.id + "/name", post).subscribe((response: any) => {
          console.log(response)
          this.kryptomon.name = name;
          this.oldKryptomonName = name;
          //this.showKryptomonOff = false;
          //this.loadingName = false; 
        })
      });
    }
  }

  async setAllowance() {
    console.log('allowance')
    let allowance = await this.tokenService.contract.methods.allowance(this.wallet, this.nftv2Service.contract._address).call();
    this.hasAllowance = BigNumber.from(allowance).gt(0);
    console.log(this.hasAllowance)
  }

  grantAllowance() {
    this.loadingAllowance = true;
    this.tokenService.contract.methods.approve(this.nftv2Service.contract._address, this.web3Service.toWei(999999999999)).send({
      from: this.wallet
    }).then((result) => {
      console.log(result)
      if (result.events.Approval !== undefined) {
        this.hasAllowance = true;
        this.loadingAllowance = false;
      }
    }).catch((err) => {
      this.hasAllowance = false;
      this.loadingAllowance = false;
      this.toastService.genericError();
    });;
  }

  async startHatching() {

    if (this.kmonBalance < 100) {
      this.toastService.add({
        severity: 'error',
        summary: 'errorMsg.notEnoughKMON',
        detail: 'errorMsg.need100Kmon',
        life: 10000
      })
    } else {
      //this.kryptomonHatch = this.kryptomon;
      this.kryptomon.hatching = true;
      //waiting for the transaction to be successfull
      await this.nftv2Service.contract.methods.evolveKryptomon(this.kryptomon.tokenId).send({
        from: this.wallet
      }).then((response) => {
        console.log(response)
        if (response.events.EggHatched) {
          setTimeout(() => {
            window.localStorage.setItem('somethingChanged', 'true')
            analytics.track("upgraded kryptomon", { type: "hatch" })
            this.kryptomon.gif = environment.apiImages + "images/kryptomons/gif/kmon_" + this.kryptomon.tokenId + "_gif.gif";
            this.kryptomon.image = environment.apiImages + "images/kryptomons/png/kmon_" + this.kryptomon.tokenId + "_png.png";
            this.kryptomon.hatching = false;
            this.kryptomon.status = 1;
            //this.kryptomonHatch = this.kryptomon;
            this.kryptomon.isReadyToHatch = false;
            //this.showKryptomonOff = true;
            this.kryptomon.hatchingDate = Date.now() / 1000;
            this.kryptomon.hatchingDateFormatted = new Date(Date.now())
          }, 3000);
        } else {
          this.kryptomon.hatching = false;
          this.toastService.genericError();
        }
      }).catch((err) => {
        this.kryptomon.hatching = false;
        this.toastService.genericError();
      });
    }
  }

  async startEvolving() {
    //waiting for the transaction to be successfull
    this.kryptomon.isEvolving = true;
    await this.nftv2Service.contract.methods.evolveKryptomon(this.kryptomon.tokenId).send({
      from: this.wallet
    }).then((response) => {
      console.log(response)
      //setInterval(this.checkEvolvedKryptomon, 3000, [id, index, this]);
      window.localStorage.setItem('somethingChanged', 'true')
      setTimeout(() => {
        analytics.track("upgraded kryptomon", { type: "evolve" })
        this.kryptomon.image = environment.apiImages + "images/kryptomons-junior/png/kmon_" + this.kryptomon.tokenId + "_png.png"
        this.kryptomon.gif = environment.apiImages + "images/kryptomons-junior/gif/kmon_" + this.kryptomon.tokenId + "_gif.gif"
        this.kryptomon.isEvolving = false;
        this.kryptomon.hatchingDate = Date.now() / 1000;
        const evolutionTime = this.evolutionTimes[this.kryptomon.status];
        const nextEvolution = (parseInt(this.kryptomon.hatchingDate) + evolutionTime) * 1000;
        this.kryptomon.isReadyToEvolve = false;
      }, 3000)
    }).catch((err) => {
      this.kryptomon.isEvolving = false;
      this.toastService.genericError();
    });
  }

  isValidAddressKmon() {
    this.validAddress = this.web3Service.isValidAddress(this.receiverAddress);
  }
  //0x203A130d9a0799d95E741911049A0B77b076137d
  async initiateTransfer() {
    this.isLoading = true;
    this.nftv2Service.contract.methods.transferFrom(this.wallet, this.receiverAddress, this.kryptomon.tokenId).send({
      from: this.wallet
    }).then((item) => {
      if (item.events.Transfer) {
        window.localStorage.setItem('somethingChanged', 'true')
        this.kryptomonsV2Navigation = this.kryptomonsV2Navigation.filter((item) => {
          return item.tokenId !== this.kryptomon.tokenId
        })
        this.kryptomonsV2 = this.kryptomonsV2Navigation;

        this.isSuccess = true;
        this.isLoading = false;
      } else {
        this.isSuccess = false;
        this.isLoading = false;
        this.toastService.genericError();
      }
      console.log(item);
    }, (err) => {
      this.isSuccess = false;
      this.isLoading = false;
      this.toastService.genericError();
    })
  }

  closeTransferProcedure() {
    this.showTransferModal = false;
    this.isSuccess = false;
    if (this.navigatingIndex > 0) {
      this.navigatingIndex--;
    }
    if (this.kryptomonsV2.length == 0) {
      this.router.navigate(["/kryptomons"])
    } else {
      this.router.navigate(['/kryptomons/details', this.kryptomonsV2Navigation[this.navigatingIndex]])
    }
  }

  async initiateSaleListing() {
    this.isLoading = true;
    let allowance = await this.nftv2Service.contract.methods.isApprovedForAll(this.wallet, "0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF").call();
    console.log(allowance)
    if (allowance) {
      this.executeListing()
    } else {
      this.nftv2Service.contract.methods.setApprovalForAll("0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF", true).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.ApprovalForAll !== undefined) {
          this.executeListing()
        } else {
          this.isLoading = false;
          //this.loadingTxKryptomon = false;
          this.toastService.genericError()
        }
      }).catch((err) => {
        this.isLoading = false;
        //this.loadingTxKryptomon = false;
        console.log('allowance failed')
        this.toastService.genericError()
      });;
    }

  }

  async executeListing() {
    this.marketPlaceService.contract.methods.createOrder("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.kryptomon.tokenId, this.web3Service.toWei((this.listingPrice), 'ether'), "0xFFfFfFffFFfffFFfFFfFFFFFffFFFffffFfFFFfF", (this.expirationDateUnix).toString()).send({
      from: this.wallet
    }).then((item) => {
      console.log(item)
      if (item.events.OrderCreated) {
        window.localStorage.setItem('somethingChanged', 'true')
        setTimeout(() => {
          this.isLoading = false;
          this.isSuccess = true;
        }, 5000)
      } else {
        this.isLoading = false;
        this.isSuccess = false;
        this.toastService.genericError()
      }

    }, (err) => {
      this.toastService.genericError()
      this.isLoading = false;
      this.isSuccess = false;
      console.log(err)
    })
  }

  async initiateBidOffer() {
    this.isLoading = true;
    let allowance = await this.tokenService.contract.methods.allowance(this.wallet, "0x51EeD96088ED0f6F63C1073d55092bF95a5227fc").call();
    let hasAllowance = BigNumber.from(allowance).gt(0);
    if (hasAllowance) {
      this.executeBidding()
    } else {
      this.tokenService.contract.methods.approve("0x51EeD96088ED0f6F63C1073d55092bF95a5227fc", this.web3Service.toWei(999999999999)).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Approval !== undefined) {
          this.executeBidding()
        } else {
          this.isLoading = false;
          //this.loadingTxKryptomon = false;
          this.toastService.genericError()
        }
      }).catch((err) => {
        this.isLoading = false;
        //this.loadingTxKryptomon = false;
        console.log('allowance failed')
        this.toastService.genericError()
      });;
    }
  }

  executeBidding() {
    console.log('got allowance')
    let weiBid = this.web3Service.toWei(this.bidAmount)
    console.log(this.expirationDateUnix)
    let today = new Date().getTime();
    let expiryDelta = Math.round((this.expirationDateUnix - today) / 1000)
    this.marketPlaceBidService.contract.methods.placeBid("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.kryptomon.tokenId, weiBid, "0xc732b6586a93b6b7cf5fed3470808bc74998224d", (expiryDelta).toString()).send(({
      from: this.wallet
    })).then((result) => {

      if (result.events.BidCreated) {
        setTimeout(() => {
          this.isLoading = false;
          this.isSuccess = true;
        }, 5000)
        var currencyPaid: string;
        if (this.kryptomon.order.paymentToken == "0x0000000000000000000000000000000000000000") {
          currencyPaid = "BNB"
        } else {
          currencyPaid = "KMON"
        }

        if (this.kryptomon.order) {
          var onSale: any = this.kryptomon.order.priceUSD;
        } else {
          var onSale: any = false
        }

        analytics.track('Bid Kryptomon', {
          // bidAmountUSD: Math.round((parseFloat(this.appComponent.contractService.web3.utils.fromWei(this.bidAmount))) * this.kmonValue * 100) / 100, // dollar amount
          bidAmountUSD: Math.round(this.web3Service.fromWeiFloat(this.bidAmount) * this.kmonValue * 100) / 100,// dollar amount
          bidAmountKMON: this.bidAmount, // usd
          tokenId: this.kryptomon.nft.tokenId, // id of kryptomon that's sold
          buyerId: this.wallet, // id of buyer
          sellerId: this.kryptomon.order.owner, // id of seller
          rank: this.kryptomon.tierName, // veteran/elite/rookie
          rankRaw: this.kryptomon.ranking,// number
          onSale: onSale
        });
      } else {
        this.isLoading = false;
        this.isSuccess = false;
        this.toastService.genericError()
      }

    }, (err) => {
      this.toastService.genericError()
      this.isLoading = false;
      this.isSuccess = false;
      console.log(err)
    })
  }

  initiatePurchase() {
    console.log(this.kmonBalance)
    console.log(this.bnbBalanceInit)
    this.partnerContext = uuidv4();
    this.isLoading = true;
    if (this.kryptomon.order.paymentToken == "0x0000000000000000000000000000000000000000") {
      if (parseInt(this.web3Service.toWei(this.bnbBalanceInit)) >= parseInt(this.kryptomon.order.price)) {
        this.checkAllowanceKryptomon();
      } else {
        this.initiateSimplex('bnb')
      }
    } else {
      var kmontopay: string;
      if (this.kryptomon.order.paymentToken == "0xffffffffffffffffffffffffffffffffffffffff") {
        kmontopay = this.web3Service.toWei(this.kryptomon.order.priceKMON)
      } else {
        kmontopay = this.kryptomon.order.price
      }

      console.log(this.web3Service.toWei(this.kmonBalance))
      console.log(kmontopay)
      console.log(this.kmonBalance)
      console.log(this.web3Service.toWei(this.kmonBalance) < kmontopay)
      if (parseInt(this.web3Service.toWei(this.kmonBalance)) >= parseInt(kmontopay)) {
        this.checkAllowanceKryptomon();
      } else {
        this.initiateSimplex('kmon')
      }
    }
  }

  initiateSimplex(what) {
    this.isLoading = true;
    let post = { walletId: this.wallet, amount: (this.kryptomon.order.priceUSD + 5) };
    this.amountSelected = this.kryptomon.order.priceUSD + 5;
    console.log(post)
    this.srcOnramper = this.getSrcOnramper();
    timer(0, 1000).pipe(
      take(1)).subscribe(_ => this.showOnramper = true);

    // this.http.post("https://api.kryptomon.co/simplex/makePurchase.php", post).subscribe((item: any) => {
    //   console.log(item)

    //   if (item.status == "done") {
    //     this.showWidget = true;
    //     const params = {
    //       payment_id: item.payload.paymentId
    //     }

    //     Simplex.load(params, (event) => {

    /*setTimeout(()=>{
                this.checkBnbPurchase(0, what)
                this.simulateSuccess = true
              },10000)*/

    //       Simplex.subscribe('onlineFlowFinished', (event) => {
    //         if (event.payload.result == "success") {
    //           //this.isLoading = false;
    // this.checkBnbPurchase(0, what)
    // setTimeout(() => {
    //   this.checkBnbPurchase(0, what)
    //   //this.simulateSuccess = true
    // }, 10000)
    //         } else {
    //           this.isLoading = false;
    //           console.log('ops something went wrong')
    //           this.toastService.genericError()
    //         }
    //       })
    //     })
    //   } else {
    //     this.isLoading = false;
    //     this.toastService.genericError()
    //   }
    // })
  }

  closeOnramper() {
    if (this.showOnramper) {
      this.showOnramper = false;
      this.isLoading = false;
      this.checkOnramperTransactionStatus();
    }
  }

  checkOnramperTransactionStatus() {
    const maxAttempts = 10;
    const interval = 6000; // 6 seconds
    let attempts = 0;
    this.isLoading = true;
    timer(0, interval)
      .pipe(
        takeWhile(() => attempts < maxAttempts),
        // https://api-staging-n7ni4.ondigitalocean.app/onramper/status/
        // switchMap(() => this.http.get<any>('http://localhost:5530/onramper/status/' + this.partnerContext))
        switchMap(() => this.http.get<any>('https://stingray-app-4qz4a.ondigitalocean.app/onramper/status/' + this.partnerContext))
      )
      .subscribe(
        response => {
          if (response.status === 'completed') {
            console.log('attempts: ' + attempts);
            //Convert directly
            this.convertBNBtoKMON(this.bnbAmountToConvert);
            this.isLoading = false;
            attempts = maxAttempts;
          } else if (response.status === 'pending') {
            attempts++;
            console.log(`Attempt ${attempts} - answer: ${response.status}`);
            this.isLoading = true;
          } else {
            this.toastService.genericError();
            this.isLoading = false;
          }
        },
        error => {
          if (error.status === 404) console.error('Transaction not executed:', error);
          this.isLoading = false;
        }
      );
  }


  getSrcOnramper() {
    // this.onramperQueryParam['defaultAmount'] = '';
    this.onramperQueryParam['defaultAmount'] = this.amountSelected;
    this.onramperQueryParam['networkWallets'] = ONRAMPER_QUERY_PARAM()['networkWallets'];
    this.onramperQueryParam['networkWallets'] += this.wallet;
    this.onramperQueryParam['partnerContext'] = this.partnerContext;
    // console.log(this.onramperQueryParam);
    this.onramperQUeryParamString = convertJSONToQueryParam(this.onramperQueryParam);
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://buy.onramper.com/?' + this.onramperQUeryParamString
    );
  }

  async checkBnbPurchase(timer, what) {
    Simplex.unload();
    this.waitingForFunds = true;
    //this.loadingSwap = true;
    const balanceBnb = await this.web3Service.getWeb3().eth.getBalance(this.wallet);
    let newBnbBalance = this.web3Service.fromWeiFloat(balanceBnb);
    if (newBnbBalance > this.bnbBalanceInit || this.simulateSuccess) {
      let bnbReceived = newBnbBalance - this.bnbBalanceInit;
      this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
        this.fundsArrived = true;

        if (what == 'kmon') {
          var amountToConvert = bnbReceived - Math.round(5 / item.wbnb.usd * 100) / 100
          this.checkAllowance(amountToConvert)
        } else {
          this.checkAllowanceKryptomon();
        }

      })
    } else {
      if (timer == 60) {
        this.isLonger = true;
      } else {
        setTimeout(() => {
          timer = timer + 1;
          this.checkBnbPurchase(timer, what);
        }, 5000)
      }
    }

  }

  async checkAllowance(bnbReceived) {
    let allowance = await this.bnbService.contract.methods.allowance(this.wallet, "0x10ED43C718714eb63d5aA57B78B54704E256024E").call();
    let hasAllowanceBNBKMON = BigNumber.from(allowance).gt(0);
    if (hasAllowanceBNBKMON) {
      this.convertBNBtoKMON(bnbReceived)
    } else {
      this.bnbService.contract.methods.approve("0x10ED43C718714eb63d5aA57B78B54704E256024E", this.web3Service.toWei(999999999999)).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Approval !== undefined) {
          this.convertBNBtoKMON(bnbReceived)
        } else {
          this.isLoading = false;
          this.loadingSwap = false
          this.toastService.genericError()
        }
      }).catch((err) => {
        this.isLoading = false;
        this.loadingSwap = false
        this.toastService.genericError()
        console.log('allowance failed')
      });;
    }
  }

  async convertBNBtoKMON(bnbAmount = 0.0001) {

    this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
      let minKmonAmount = bnbAmount / item.kryptomon.bnb * 0.80;
      let bnbAmountWei = this.web3Service.toWei(bnbAmount);
      let minKmonAmountWei = this.web3Service.toWei(minKmonAmount);
      let path = ["0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D"]
      let expiry = Math.floor(Date.now() / 1000) + 60 * 10;
      let expireWei = this.web3Service.toWei(expiry);
      console.log(bnbAmount)
      this.pancakeV2Service.contract.methods.swapExactETHForTokens(minKmonAmountWei, path, this.wallet, expireWei).send({
        from: this.wallet,
        value: bnbAmountWei
      }).then((item) => {
        if (item.status) {
          //this.purchaseCompleted = true;
          this.checkAllowanceKryptomon();
          this.loadingSwap = false
          //this.successTxSwap = true;
        } else {
          this.isLoading = false;
          this.loadingSwap = false
          this.toastService.genericError()
        }
      }).catch((err) => {
        this.isLoading = false;
        this.loadingSwap = false
        this.toastService.genericError()
      })
    }, (err) => {
      this.isLoading = false;
      this.loadingSwap = false
      this.toastService.genericError()
    })

  }

  async checkAllowanceKryptomon() {
    console.log(this.wallet)
    //this.loadingTxKryptomon = true;
    let allowance = await this.tokenService.contract.methods.allowance(this.wallet, "0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF").call();
    let hasAllowanceNFT = BigNumber.from(allowance).gt(0);
    if (hasAllowanceNFT) {
      console.log('qua ci sono')
      this.startPurchaseKryptomon()
    } else {
      this.tokenService.contract.methods.approve("0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF", this.web3Service.toWei(999999999999)).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Approval !== undefined) {
          this.startPurchaseKryptomon()
        } else {
          this.isLoading = false;
          //this.loadingTxKryptomon = false;
          this.toastService.genericError()
        }
      }).catch((err) => {
        this.isLoading = false;
        //this.loadingTxKryptomon = false;
        console.log('allowance failed')
        this.toastService.genericError()
      });;
    }
  }

  async startPurchaseKryptomon() {
    console.log(this.kryptomon.nft.contractAddress)
    console.log(this.kryptomon.nft.tokenId)
    console.log(this.kryptomon.order.price)
    console.log(this.kryptomon.order.paymentToken)
    await this.marketPlaceService.contract.methods.executeOrder(
      this.kryptomon.nft.contractAddress,
      this.kryptomon.nft.tokenId,
      this.kryptomon.order.price,
      this.kryptomon.order.paymentToken
    ).send({
      from: this.wallet
    }).then((item) => {
      console.log(item)
      if (item.status) {
        //this.loadingTxKryptomon = false;
        //this.successTxKryptomon = true;
        setTimeout(() => {
          this.isSuccess = true;
          this.isLoading = false;
        }, 5000)

        if (this.kryptomon.order.paymentToken == "0x0000000000000000000000000000000000000000") {
          var currencyPaid = "BNB"
        } else {
          var currencyPaid = "KMON"
        }

        analytics.track('Buy Kryptomon', {
          price: this.kryptomon.order.priceUSD, // dollar amount
          currency: "USD", // usd
          currencyPaid: currencyPaid, // actual currency (kmon or bnb)
          pricePaid: this.kryptomon.order.tokenPaymentAmount, // actual amount paid (double because for conversion events it needs dollars)
          tokenId: this.kryptomon.nft.tokenId, // id of kryptomon that's sold
          buyerId: this.wallet, // id of buyer
          sellerId: this.kryptomon.order.owner, // id of seller
          rank: this.kryptomon.tierName, // veteran/elite/rookie
          rankRaw: this.kryptomon.ranking// number
        });
      } else {
        this.isLoading = false;
        //this.loadingTxKryptomon = false;
        this.toastService.genericError()
      }

    }).catch((err) => {
      this.isLoading = false;
      this.toastService.genericError()
      //this.loadingTxKryptomon = false;
    })
  }

  removeSale() {
    this.isLoading = true;
    this.marketPlaceService.contract.methods.cancelOrder("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.kryptomon.tokenId).send({
      from: this.wallet
    }).then((item) => {
      if (item.events.OrderCancelled) {
        window.localStorage.setItem('somethingChanged', 'true')
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
          this.kryptomon.order = undefined;
        }, 3000)
      } else {
        this.toastService.genericError()
        this.isSuccess = false;
      }
      this.isLoading = false;
    }, (err) => {
      this.toastService.genericError()
      this.isLoading = false;
      this.isSuccess = false;
    })
  }

  closeListingProcedure() {
    this.showSaleModal = false;
    this.isSuccess = false;
    this.showConfirmationListing = false;
    this.getDetails(this.kryptomon.tokenId)
  }

  closeBiddingProcedure() {
    this.showBidModal = false;
    this.isSuccess = false;
    this.showConfirmationBidding = false;
    this.bidAmount = 0;
  }

  closeBuyingProcedure() {
    this.showBuyModal = false;
    this.isLoading = false;
    this.isSuccess = false;
    this.getDetails(this.kryptomon.tokenId)
  }

  async initiateBreedListing() {
    this.isLoading = true;
    let allowance = await this.tokenService.contract.methods.allowance(this.wallet, "0x04B0f7d5CB2CE4688497f2525748FB7A9aFFa394").call();
    let hasAllowance = BigNumber.from(allowance).gt(0);
    console.log(hasAllowance)
    if (hasAllowance) {
      this.executeBreedListing()
    } else {
      this.tokenService.contract.methods.approve("0x04B0f7d5CB2CE4688497f2525748FB7A9aFFa394", this.web3Service.toWei(999999999999)).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Approval !== undefined) {
          this.executeBreedListing()
        } else {
          this.isLoading = false;
          //this.loadingTxKryptomon = false;
          this.toastService.genericError()
        }
      }).catch((err) => {
        this.isLoading = false;
        //this.loadingTxKryptomon = false;
        console.log('allowance failed')
        this.toastService.genericError()
      });;
    }
  }

  async executeBreedListing() {
    this.nftv2Service.contract.methods.addToBreedingCentre(this.kryptomon.tokenId, this.web3Service.toWei((this.breedingPrice), 'ether')).send({
      from: this.wallet
    }).then((item) => {
      console.log(item)
      if (item.events.AddToBreedingCentre) {
        window.localStorage.setItem('somethingChanged', 'true')
        setTimeout(() => {
          this.isLoading = false;
          this.isSuccess = true;
        }, 5000)
      } else {
        this.isLoading = false;
        this.isSuccess = false;
        this.toastService.genericError()
      }
    }, (err) => {
      this.toastService.genericError()
      this.isLoading = false;
      this.isSuccess = false;
    })
  }

  removeFromBreedingCenter() {
    this.isLoading = true;
    this.nftv2Service.contract.methods.removeFromBreedingCentre(this.kryptomon.tokenId).send({
      from: this.wallet
    }).then((item) => {
      console.log(item)
      if (item.events.RemoveFromBreedingCentre) {
        window.localStorage.setItem('somethingChanged', 'true')
        this.chunkedSkills[1][1].skills[0].value = 0;
      } else {
        this.toastService.genericError()
      }
      this.isLoading = false;
    }, (err) => {
      this.toastService.genericError()
      this.isLoading = false;
    })
  }

  closeBreedListingProcedure() {
    this.showBreedModal = false;
    this.isSuccess = false;
    this.getDetails(this.kryptomon.tokenId)
  }

  checkDateValidity($event) {
    let selectedDate = new Date($event);
    let today = new Date()
    if (selectedDate > today) {
      this.expirationDateUnix = selectedDate.getTime();
    } else {
      this.expirationDateUnix = 0;
    }
  }

  checkDateValidityBid($event) {
    let selectedDate = new Date($event);
    let todaycheck = new Date();
    let today = new Date();
    let six_months = new Date(today.setMonth(today.getMonth() + 6))
    if (selectedDate > todaycheck && selectedDate < six_months) {
      this.expirationDateUnix = selectedDate.getTime();
    } else {
      this.expirationDateUnix = 0;
    }
  }

  updateKMONPrice() {
    let kmonPrice = this.listingPrice / this.kmonValue;
    console.log(kmonPrice)
    if (kmonPrice >= 1000) {
      this.kmonPrice = (Math.round(kmonPrice / 1000 * 100) / 100).toLocaleString() + "K"
    } else {
      this.kmonPrice = (Math.round(kmonPrice * 100) / 100).toLocaleString()
    }
  }

  selectSpell(index) {
    console.log(index)
    this.spellName = this.spells[index].name;
    this.spellDescription = this.spells[index].description;
    console.log(this.spellDescription)
  }

  async getKmonBalance() {
    const balance = await this.tokenService.contract.methods.balanceOf(this.wallet).call();
    this.kmonBalance = this.web3Service.fromWeiFloat(balance)
    const balanceBnb = await this.web3Service.getWeb3().eth.getBalance(this.wallet);
    this.bnbBalanceInit = this.web3Service.fromWeiFloat(balanceBnb)
  }

  openNewDetails(id) {
    this.router.navigate(['/kryptomons/details', id])
    //this.populatePage(id)
  }

  openPlaydex(id) {
    console.log(id)
    //window.open('https://playdex.io/games/kryptomon/assets/'+id, '_blank')
    this.router.navigate(['/renting-house', id])
  }

  formatDate(dateUnix) {
    const date = new Date(dateUnix * 1000);
    const yyyy = date.getFullYear();
    let mm: any = date.getMonth() + 1; // Months start at 0!
    let dd: any = date.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const dateFormatted = dd + '/' + mm + '/' + yyyy;
    return dateFormatted
  }

  async hatchFree2Play() {
    this.kryptomon.hatching = true;
    let timestamp = Date.now();
    var text = "Evolve my starter " + this.kryptomon.tokenId + " kryptomon to " + (this.kryptomon.status + 1);
    var msg = this.web3Service.utf8ToHex(text)
    var from = this.wallet;
    var params = [msg, from]
    var method = 'personal_sign'
    console.log(from)
    this.web3Service.getWeb3().currentProvider.sendAsync({
      method,
      params,
      from,
    }, (err: any, result: any) => {
      console.log('fired')
      this.zone.run(() => {
        if (err || result.error) {
          console.log(err);
          console.log(result)
          this.kryptomon.hatching = false;
          this.toastService.genericError();
        } else {
          let post = {
            tokenId: this.kryptomon.tokenId,
            walletId: this.wallet,
            signatureHash: result.result,
            timestamp: timestamp,
            status: this.kryptomon.status
          }
          console.log(post)
          this.http.post(environment.apiBaseUrl + "f2p/evolveKryptomon.php", post).subscribe((item: any) => {
            console.log(item)
            if (item.response == 'done') {
              window.localStorage.setItem('somethingChanged', 'true')
              setTimeout(() => {
                analytics.track("upgraded f2p kryptomon", { type: "hatch" })
                this.kryptomon.gif = environment.apiImages + "images/kryptomons/gif/kmon_" + this.kryptomon.tokenId + "_gif.gif";
                this.kryptomon.image = environment.apiImages + "images/kryptomons/png/kmon_" + this.kryptomon.tokenId + "_png.png";
                this.kryptomon.hatching = false;
                //this.kryptomonHatch = this.kryptomon;
                this.kryptomon.isReadyToHatch = false;
                this.kryptomon.status = 1;
                //this.showKryptomonOff = true;
                this.kryptomon.hatchingDate = Date.now() / 1000;
                this.kryptomon.hatchingDateFormatted = new Date(Date.now())
              }, 3000);
            } else {
              this.kryptomon.hatching = false;
              this.toastService.genericError();
            }
          }, (err) => {
            this.kryptomon.hatching = false;
            console.log(err)
            this.toastService.genericError();
          })
        }
      })
    })
  }

  async evolveFree2Play() {
    this.kryptomon.isEvolving = true;
    let timestamp = Date.now();
    var text = "Evolve my starter " + this.kryptomon.tokenId + " kryptomon to " + (this.kryptomon.status + 1);
    var msg = this.web3Service.utf8ToHex(text)
    var from = this.wallet;
    var params = [msg, from]
    var method = 'personal_sign'
    console.log(from)
    this.web3Service.getWeb3().currentProvider.sendAsync({
      method,
      params,
      from,
    }, (err: any, result: any) => {
      console.log('fired')
      this.zone.run(() => {
        if (err || result.error) {
          console.log(err);
          console.log(result)
          this.kryptomon.hatching = false;
          this.toastService.genericError();
        } else {
          let post = {
            tokenId: this.kryptomon.tokenId,
            walletId: this.wallet,
            signatureHash: result.result,
            timestamp: timestamp,
            status: this.kryptomon.status
          }
          console.log(post)
          this.http.post("https://api.kryptomon.co/f2p/evolveKryptomon.php", post).subscribe((item: any) => {
            console.log(item)
            if (item.response == 'done') {
              window.localStorage.setItem('somethingChanged', 'true')
              setTimeout(() => {
                analytics.track("upgraded f2p kryptomon", { type: "evolve" })
                this.kryptomon.image = environment.apiImages + "images/kryptomons-junior/png/kmon_" + this.kryptomon.tokenId + "_png.png"
                this.kryptomon.gif = environment.apiImages + "images/kryptomons-junior/gif/kmon_" + this.kryptomon.tokenId + "_gif.gif"
                this.kryptomon.isEvolving = false;
                this.kryptomon.hatchingDate = Date.now() / 1000;
                const evolutionTime = this.evolutionTimes[this.kryptomon.status];
                const nextEvolution = (parseInt(this.kryptomon.hatchingDate) + evolutionTime) * 1000;
                this.kryptomon.isReadyToEvolve = false;
              }, 3000);
            } else {
              this.kryptomon.isEvolving = false;
              this.toastService.genericError();
            }
          }, (err) => {
            this.kryptomon.isEvolving = false;
            console.log(err)
            this.toastService.genericError();
          })
        }
      })
    })
  }

  async destroySyntethic() {
    this.kryptomon.isDestroying = true;
    let timestamp = Date.now();
    var text = "Delete my starter " + this.kryptomon.tokenId + " kryptomon";
    var msg = await this.web3Service.getWeb3().utils.utf8ToHex(text)
    var from = this.wallet;
    var params = [msg, from]
    var method = 'personal_sign'
    console.log(from)
    this.web3Service.getWeb3().currentProvider.sendAsync({
      method,
      params,
      from,
    }, (err: any, result: any) => {
      console.log('fired')
      if (err || result.error) {
        console.log(err);
        console.log(result)
        this.isLoading = false;
      } else {
        this.zone.run(() => {
          console.log(result)
          let post = { signature: result.result, wallet: this.wallet, entityToken: this.getCookieValue("playfab-entity-token"), timestamp: timestamp };
          console.log(post)
          this.http.post("https://api-v22.kryptomon.co/kryptomon-starters/delete/" + this.kryptomon.tokenId, post).subscribe((item: any) => {
            console.log(item);
            window.localStorage.setItem('somethingChanged', 'true')
            this.router.navigate(["/kryptomons"])
          }, (err) => {
            console.log(err);
            this.toastService.genericError();
            this.kryptomon.isDestroying = false;
          })
        })
      }
    })

  }

  migrateKryptomon() {
    this.toastService.add({
      severity: 'error',
      summary: 'toastMessage.comingSoon',
      detail: 'toastMessage.featureNotAvailable',
      life: 15000
    });
  }

  openBreed() {
    this.router.navigate(['/breeding', this.kryptomon.tokenId])
  }

  getAge(dateString, isStarter) {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    var yearNow = now.getFullYear();
    var monthNow = now.getMonth();
    var dateNow = now.getDate();

    if (isStarter) {
      var dob = new Date(dateString);
    } else {
      var dob = new Date(dateString * 1000);
    }

    console.log(dob)
    var yearDob = dob.getFullYear();
    var monthDob = dob.getMonth();
    var dateDob = dob.getDate();
    var age: any = {};
    var ageString = "";
    var yearString = "";
    var monthString = "";
    var dayString = "";


    var yearAge = yearNow - yearDob;

    if (monthNow >= monthDob)
      var monthAge = monthNow - monthDob;
    else {
      yearAge--;
      var monthAge = 12 + monthNow - monthDob;
    }

    if (dateNow >= dateDob)
      var dateAge = dateNow - dateDob;
    else {
      monthAge--;
      var dateAge = 31 + dateNow - dateDob;

      if (monthAge < 0) {
        monthAge = 11;
        yearAge--;
      }
    }

    age.years = yearAge;
    age.months = monthAge;
    age.days = dateAge;


    if (age.years > 1) yearString = " years";
    else yearString = " year";
    if (age.months > 1) monthString = " months";
    else monthString = " month";
    if (age.days > 1) dayString = " days";
    else dayString = " day";


    if ((age.years > 0) && (age.months > 0) && (age.days > 0))
      ageString = age.years + yearString + ", " + age.months + monthString + " and " + age.days + dayString;
    else if ((age.years == 0) && (age.months == 0) && (age.days > 0))
      ageString = "Only " + age.days + dayString;
    else if ((age.years > 0) && (age.months == 0) && (age.days == 0))
      ageString = age.years + yearString + " Happy Birthday!!";
    else if ((age.years > 0) && (age.months > 0) && (age.days == 0))
      ageString = age.years + yearString + " and " + age.months + monthString;
    else if ((age.years == 0) && (age.months > 0) && (age.days > 0))
      ageString = age.months + monthString + " and " + age.days + dayString;
    else if ((age.years > 0) && (age.months == 0) && (age.days > 0))
      ageString = age.years + yearString + " and " + age.days + dayString;
    else if ((age.years == 0) && (age.months > 0) && (age.days == 0))
      ageString = age.months + monthString;
    else ageString = "I'm not born yet...";

    return ageString;
  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      console.log("clicked inside");
    } else {
      console.log("clicked outside");
      if (this.showOnramper) this.closeOnramper();
    }
  }

  getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  }
}
